import * as React from "react";

import { IText } from "./classes/Text";

export interface IUnifiedPublishingUnminimizeButton {
  displayModal: boolean;
  modalIsMinimized: boolean;
  numAlerts: number;
  text: IText;
  onUnminimizeModal: (event: any) => any;

}

export const UnifiedPublishingUnminimizeButton = (props: IUnifiedPublishingUnminimizeButton) => {

  if (props.displayModal && props.numAlerts > 0) {

    let minimizeBtnClassName = "A_maximizeButton";
    if (props.displayModal && props.modalIsMinimized) { minimizeBtnClassName += " A_mbVisible"; }

    let alertsText = "";
    if (props.text) {
      alertsText = props.text.alerts;
    }

    return (
      <a type="button" onClick={props.onUnminimizeModal} className={minimizeBtnClassName}>
        <em className="fa fa-exclamation-triangle" aria-hidden="true"></em> 
        {alertsText} 
        <span>{props.numAlerts}</span>
      </a>
    );

  } else {
    return null;
  }

};
